import React, { createContext, useState, useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'
import io from 'socket.io-client';

export const DBContext = createContext();

const DBProvider = ({ children }) => {

	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const [customerCode, setCustomerCode] = useState(null);
	const [cName, setCName] = useState(() => localStorage.getItem('Name'));
	const [logginedDB, setLogginedDB] = useState(() => localStorage.getItem('DB'));
	const [user, setUser] = useState(() => localStorage.getItem('USER'));
	const [user_Id, setUser_Id] = useState(() => localStorage.getItem('UI'));
	const [userType, setUserType] = useState(() => localStorage.getItem('userType'));
	const [inventoryState, setInventoryState] = useState(false)
	const [sideNavState, setSideNavState] = useState(false)
	const [rightNavState, setRightNavState] = useState(false)
	const [companyDetails, setCompanyDetails] = useState(null)
	const [notification, setNotification] = useState(false)
	const [loading, setLoading] = useState(false); // Prevent concurrent fetches
	//   //(user);
	useEffect(() => {
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			let value = localStorage.getItem(key);

			try {
				value = JSON.parse(value); // try parsing in case it's a JSON string
			} catch (e) {
				// leave value as-is if not JSON
			}
			// console.log(`${key}:`, value);
		}
	})

	//   const [name, setName] = useState(() => localStorage.getItem('Name'));

	// //(storedEncryptedUser);

	const manageCache = async (action, data = null) => {
		if (typeof window === "undefined" || !('caches' in window)) {
			console.log('Caching is not supported outside the browser.');
			//('Caching is not supported outside the browser.');
			return;
		}

		try {
			const cache = await caches.open('customer-code');
			const customUrl = '/Sherdine';

			if (action === 'set' && data) {
				const response = new Response(JSON.stringify(data), {
					headers: { 'Content-Type': 'application/json' },
				});

				await cache.put(customUrl, response);
			} else if (action === 'delete') {
				const isDeleted = await cache.delete(customUrl);
			} else if (action === 'get') {
				const cachedResponse = await cache.match(customUrl);
				if (cachedResponse) {
					return await cachedResponse.json();
				}
			}
		} catch (error) {
			console.error('Error managing cache:', error);
		}
	};


	const fetchData = async () => {
		// Retrieve data from cache
		const Cname = localStorage.getItem('Name')
		setCName(Cname)
		const codefromsession = localStorage.getItem('Code') || await manageCache('get');
		setCustomerCode(codefromsession)
	};

	const getLogginedDB = () => {
		const DB = localStorage.getItem('DB');
		if (DB) {
			setLogginedDB(DB);
		}
	};


	const setInventoryStateFunc = (state) => {
		setInventoryState(state)
	};

	const sideNavStateFunc = (state) => {
		setSideNavState(!state)
	};

	const rightNavStateFunc = (state) => {
		setRightNavState(!state)
	};

	const getName = () => {
		const name = localStorage.getItem('USER');
		setUser(name)
	};

	const getUserType = () => {
		const name = localStorage.getItem('userType');
		// console.log("db context user type" , name);

		setUserType(name)
	};
	// console.log(userType,"qwertyuiop");

	const [userRights, setUserRights] = useState(() => {
		try {
			return JSON.parse(localStorage.getItem('userRights')) || {};
		} catch (e) {
			return {};
		}
	});

	const getUserRights = () => {
		try {
			const rights = JSON.parse(localStorage.getItem('userRights')) || {};
			setUserRights(rights);
		} catch (e) {
			setUserRights({});
		}
	};

	const hasPermission = (permission) => {
		const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER');
		if (loggedInUser === 'shersoft') {
			return true;
		}
		return !!(userRights && (userRights[permission] === 1 || userRights[permission] === true));
	};

	const logout = () => {
		setUser(null);
		setUserType(null);
		setUserRights({});
		setUser_Id(null);

		sessionStorage.removeItem("agentCode");
		sessionStorage.removeItem("userType");

		localStorage.removeItem('USER');
		localStorage.removeItem('userName');
		localStorage.removeItem('UI');
		localStorage.removeItem('userType');
		localStorage.removeItem('userRights');
		localStorage.removeItem('token');
		localStorage.removeItem('isAuthenticated');
		localStorage.removeItem('agentCode');
		localStorage.removeItem('uRights');
	};

	const exitDatabase = () => {
		logout();

		setLogginedDB(null);
		setCName(null);
		setCustomerCode(null);
		setCompanyDetails(null);

		sessionStorage.removeItem("dbCode");
		sessionStorage.removeItem("Code");

		localStorage.removeItem('DB');
		localStorage.removeItem('Name');
		localStorage.removeItem('Code');
		localStorage.removeItem('imgCode');
		localStorage.removeItem('Company');
		localStorage.removeItem('dbCode');
		localStorage.removeItem('userName');

		manageCache('delete');
	};


	// const handleGetCompanyDetails = async () => {
	// 	try {
	// 		const response = await axios.get(`${api_base_url}/getCompanyDetails/${logginedDB}`)
	// 		if (response.status == 200) {
	// 			setCompanyDetails(response.data)
	// 		}
	// 	} catch (error) {
	// 		//(error);

	// 	}
	// }

	const handleGetCompanyDetails = async () => {
		if (!logginedDB || loading) return; // Prevent fetch if no DB or already fetching
		setLoading(true);
		try {
			console.log('Fetching company details for:', logginedDB);
			const response = await axios.get(`${api_base_url}/getCompanyDetails/${logginedDB}`);
			if (response.status === 200) {
				setCompanyDetails(response.data);
			}
		} catch (error) {
			console.error('Error fetching company details:', error);
		} finally {
			setLoading(false);
		}
	};

	const handleUpdateCompanyDetails = async (updatedFields) => {
		if (!logginedDB) return;
		try {
			const response = await axios.post(`${api_base_url}/updateCompanyDetails/${logginedDB}`, updatedFields);
			if (response.status === 200) {
				setCompanyDetails(response.data);
				console.log('Company details updated successfully');
			}
		} catch (error) {
			console.error('Error updating company details:', error);
		}
	};

	useEffect(() => {
		const socket = io(api_base_url);
		socket.on('updateCompany', (data) => {
			if (data.success && data.code === logginedDB) {
				console.log('Received update notification for:', data.code);
				handleGetCompanyDetails();
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [logginedDB, api_base_url]);

	useEffect(() => {
		if (customerCode) {
			getLogginedDB()
		}
		fetchData(); // Ensure this function handles undefined logginedDB
		if (logginedDB) {
			getName(); // Ensure this function handles Name properly
			getUserType()
			getUserRights()
			handleGetCompanyDetails()
		}
		const socket = io(api_base_url)
		socket.on('companyDetails', () => {
			//('Data updated, fetching new data...');
			handleGetCompanyDetails();
		});

		return () => {
			socket.disconnect();
		};
	}, [customerCode, logginedDB, api_base_url]);
	// console.log(userType);

	return (
		<DBContext.Provider value={{
			customerCode, logginedDB, 
			user, userType,
			user_Id, inventoryState,
			cName, sideNavState, 
			rightNavState, companyDetails, 
			notification, setNotification, 
			logout, exitDatabase, fetchData, 
			getUserType, getName, 
			setLogginedDB, setInventoryStateFunc, 
			sideNavStateFunc, rightNavStateFunc,
			handleGetCompanyDetails,
			userRights, getUserRights, hasPermission
		}}>
			{children}
		</DBContext.Provider>
	);
};

export default DBProvider;